import { usingGet } from '@ocean/api'

export const getCustomerSpecificCategories = () =>
  usingGet('CustomerSpecificCategories/ListCategories', { useProxy: true })
